module.exports = __webpack_public_path__ + "static/img/03aiJa.e2d39f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/status/23checkupDesc/03aiJa.png
// module id = uS74
// module chunks = 0